import type { NavItemConfig } from '../../../../types/nav';
import { paths } from '../../../../utils/paths';

export const companyNavItems = [
  { key: 'overview', title: 'Overview', href: paths.agent.home, icon: 'chart-pie' },
  { key: 'clients', title: 'Clients', href: paths.agent.clients, icon: 'users' },
  { key: 'agents', title: 'Agents', href: paths.agent.companyAgents, icon: 'agent' },
  { key: 'tasks', title: 'Workflows & Tasks', href: paths.agent.workflows, icon: 'tasks' },
  { key: 'assessment', title: 'Assessments', href: paths.agent.assessmentView, icon: 'assessment' },
  { key: 'activities', title: 'Business Activities', href: paths.agent.activities, icon: 'activity' },
  { key: 'settings', title: 'Settings', href: paths.agent.settings, icon: 'gear-six' },
  { key: 'profile', title: 'Profile', href: paths.agent.companyProfile, icon: 'user' },
  { key: 'subscriptions', title: 'Platform & Subscriptions', href: paths.agent.companyPlatformSubscription, icon: 'subscription' },
  //{ key: 'payments', title: 'Payments', href: paths.agent.payments, icon: 'invoice' },
  { key: 'support', title: 'Support', href: paths.agent.support, icon: 'support' }
] satisfies NavItemConfig[];
